import React from 'react';
import './Cards.css';
import CardItem from './CardItem';

function Cards() {
  return (
    <div className='cards'>
      <div className='cards'>
        <div className='cards__container'>
          <div className='cards__wrapper'>
            <ul className='cards__items'>
              <CardItem
                src='images/merishia-massage.jpg'
                text='Merishia Massage'
                detail='Massage is a great way to help animals and can be used to aid sports performance and support rehabilitation'
                // label='Merishia Massage'
                path='/merishia'
              />
              <CardItem
                src='images/reiki_healing.jpg'
                text='Animal Led Reiki'
                detail='Animal Led Reiki is a non-invasive therapy and a form of energy balancing that encourages emotional and physical healing.'
                // label='Reiki'
                path='/reiki'
              />
              <CardItem
                src='images/phototherapy.jpg'
                text='Phototherapy'
                detail='Phototherapy is a non-invasive procedure that stimulates internal and external healing in your animal.'
                // label='Phototherapy'
                path='/phototherapy'
              />
              
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Cards;
